export const DEBUG = false;
export const ANIMATION_DURATION = 2500;

export const BP_DESKTOP_LARGE = 'BP_DESKTOP_LARGE';
export const BP_DESKTOP_SMALL = 'BP_DESKTOP_SMALL';
export const BP_TABLET_LARGE  = 'BP_TABLET_LARGE';
export const BP_TABLET_SMALL  = 'BP_TABLET_SMALL';
export const BP_MOBILE_LARGE  = 'BP_MOBILE_LARGE';
export const BP_MOBILE_SMALL  = 'BP_MOBILE_SMALL';

export function getBreakpoint(browser) {
	let wWidth = browser.window.wpWidth;
	if (wWidth <= 567) {
		return BP_MOBILE_SMALL;
	} else if (wWidth >= 567 && wWidth <= 719) {
		return BP_MOBILE_LARGE;
	} else if (wWidth >= 720 && wWidth <= 999) {
		return BP_TABLET_SMALL;
	} else if (wWidth >= 1000 && wWidth <= 1199) {
		return BP_TABLET_LARGE;
	} else if (wWidth >= 1200 && wWidth <= 1439) {
		return BP_DESKTOP_SMALL;
	} else {
		return BP_DESKTOP_LARGE;
	}
}

export function getColNumber(bp) {
	let cols = 3;

	if (bp === BP_TABLET_LARGE || bp === BP_TABLET_SMALL) {
		cols = 2;
	} else if (bp === BP_MOBILE_LARGE || bp === BP_MOBILE_SMALL) {
		cols = 1;
	}

	return cols;
}

export function getRow(rank, cols, rankOffset) {
	if (rank === 1) {
		return 0;
	}

	return Math.ceil(((rank + rankOffset) - 1) / cols);
}

export function getCol(rank, cols, rankOffset) {
	if (rank === 1) {
		return 0;
	}

	return ((rank + rankOffset) - (2)) % cols;
}

export function getRankColOffset(rank, divideAt, cols) {
	if (rank > divideAt) {
		//rank += (cols - (((divideAt - 1) + (cols - 1)) % cols));
		if (cols === 1) {
			return 0;
		}

		switch (divideAt % cols) {
			case 0:
				return 1;
			case 1:
				return 0;
			case 2:
				return 2;
		}
	}

	return 0;
}

export function getElementDimensions(bp) {
	switch (bp) {
		case BP_MOBILE_SMALL:
			return {
				w: 313,
				h: 305,
			};
		case BP_MOBILE_LARGE:
			return {
				w: 537,
				h: 425,
			};
		case BP_TABLET_SMALL:
			return {
				w: 303,
				h: 294,
			};
		case BP_TABLET_LARGE:
			return {
				w: 411,
				h: 351,
			};
		case BP_DESKTOP_SMALL:
			return {
				w: 322,
				h: 288,
			};
		default:
			return {
				w: 390,
				h: 319,
			};
	}
}

export function getSplitterOffset(bp) {
	switch (bp) {
		case BP_MOBILE_SMALL:
			return 126 + 69;
		case BP_MOBILE_LARGE:
			return 126 + 69;
		case BP_TABLET_SMALL:
			return 202;
		case BP_TABLET_LARGE:
			return 202;
		case BP_DESKTOP_SMALL:
			return 388;
		default:
			return 388;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/containers/livejudging/livehelper.js
 **/